import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './SliderInput.scss';
const SliderInput = ({ 
// label, // Removed
// id, // Removed
min, max, step, value, onChange, disabled = false, unit = '', showValue = true }) => {
    const handleChange = (event) => {
        const newValue = parseFloat(event.target.value);
        if (!isNaN(newValue)) {
            onChange(newValue); // Call the passed onChange with the number value
        }
    };
    // Format the displayed value
    // Display the value directly, possibly rounding if needed for display
    const displayValue = `${Math.round(value)}${unit}`;
    // Slider should use the passed props directly
    const sliderValue = value;
    const sliderMax = max;
    const sliderMin = min;
    const sliderStep = step;
    return (
    // Removed the outer label and form-group div, will be handled by parent
    // <div className={`form-group slider-input-group ${disabled ? 'disabled' : ''}`}>
    //     <label htmlFor={id} className="slider-label">
    //         {label}
    //     </label>
    _jsxs("div", { className: "slider-container", children: [_jsx("input", { type: "range", 
                // id={id} // Removed
                // name={id} // Removed, name not strictly needed for range
                min: sliderMin, max: sliderMax, step: sliderStep, value: sliderValue, onChange: handleChange, disabled: disabled, className: "slider" }), showValue && _jsx("span", { className: "slider-value", children: displayValue })] })
    // </div>
    );
};
export default SliderInput;
